const SupportText = () => {
  return (
    <div className="sticky bottom-0 left-0 right-0 text-xs text-gray-500 text-center py-0.5 bg-white border-t border-gray-100">
      Customer support: 305-900-3020 \ support@designhinge.com
    </div>
  );
};

export default SupportText;
